<template src="./help.html"></template>

<script>
  export default {
    mounted: function () {
      /**
       * Initialise Semantic UI accordion
       */
      $(this.$el).find('.ui.accordion').accordion()

      /**
       * Initialise Semantic UI accordion
       */
      $(this.$el).find('.ui.dropdown').dropdown()
    }
  }
</script>

<style>

</style>
